import { CreditEventType } from 'constants/loanApplication';

export const CreditEventDateKey = {
  BANKRUPTCY_FILING_DATE: 'bankruptcyFilingDate',
  BANKRUPTCY_DISCHARGE_DATE: 'bankruptcyDischargeDate',
  BANKRUPTCY_DISMISSAL_DATE: 'bankruptcyDismissalDate',
  FORECLOSURE_COMPLETION_DATE: 'foreclosureCompletionDate',
  SHORT_SALE_DATE: 'shortSaleDate',
  DEED_IN_LIEU_DATE: 'deedInLieuDate',
};

export const CREDIT_EVENT_DATES_OVERRIDDEN_KEY = 'creditEventDatesOverridden';

export const CREDIT_EVENT_FORM_KEYS = [
  ...Object.values(CreditEventDateKey),
  CREDIT_EVENT_DATES_OVERRIDDEN_KEY,
];

const BANKRUPTCY_DATE_KEYS = [
  CreditEventDateKey.BANKRUPTCY_FILING_DATE,
  CreditEventDateKey.BANKRUPTCY_DISCHARGE_DATE,
  CreditEventDateKey.BANKRUPTCY_DISMISSAL_DATE,
];

// Each loan-officer event date, the declaration whose Yes shows it, and the credit-report columns
// that also show it (the credit report can carry an event the borrower declared No to).
export const CREDIT_EVENT_GROUPS = [
  {
    eventType: CreditEventType.BANKRUPTCY,
    declarationKey: 'isLastMonthsBankruptcy',
    dateKeys: BANKRUPTCY_DATE_KEYS,
    creditDateKeys: [
      'creditBankruptcyFilingDate',
      'creditBankruptcyDischargeDate',
      'creditBankruptcyDismissalDate',
    ],
  },
  {
    eventType: CreditEventType.FORECLOSURE,
    declarationKey: 'isLastMonthsForeclosure',
    dateKeys: [CreditEventDateKey.FORECLOSURE_COMPLETION_DATE],
    creditDateKeys: ['creditForeclosureDate'],
  },
  {
    eventType: CreditEventType.SHORT_SALE,
    declarationKey: 'foreclosureSoldLessOutstandingBalanceWithinPastSevenYears',
    dateKeys: [CreditEventDateKey.SHORT_SALE_DATE],
    creditDateKeys: ['creditShortSaleDate'],
  },
  {
    eventType: CreditEventType.DEED_IN_LIEU,
    declarationKey: 'propertyInLieuOfForeclosureInPastSevenYears',
    dateKeys: [CreditEventDateKey.DEED_IN_LIEU_DATE],
    creditDateKeys: ['creditDeedInLieuDate'],
  },
];

export const CREDIT_EVENT_DATES_GROUP_TITLE = 'Credit event dates';

export const CREDIT_EVENT_DATES_OVERRIDDEN_LABEL = 'Use only the dates entered here';

export const FUTURE_DATE_MESSAGE = 'The date must not be in the future';

export const BEFORE_FILING_DATE_MESSAGE = 'The date must not be before the bankruptcy filing date';

export const CREDIT_REPORT_FINANCES_KEYS = [
  'creditBankruptcyChapter',
  'creditBankruptcyFilingDate',
  'creditBankruptcyDischargeDate',
  'creditBankruptcyDismissalDate',
  'creditForeclosureDate',
  'creditShortSaleDate',
  'creditDeedInLieuDate',
  'creditEventReliability',
  'creditEventsCreditReportId',
  'creditEventsUpdatedDate',
  'derogatoryEvents',
];
